module.exports = __webpack_public_path__ + "img/tw-icon.193154aa.svg";